<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <span>Vendor : </span>
        <select v-model="selectedVendor">  
          <option value="">-</option>
          <option v-for="(item, key) in vendorsList" :key="key" :value="item.id">{{ item.short_name }}</option>
        </select>
      </div>
    </div>
    <DataTable
      ref="datatable"
      :settings="datatable.settings"
      :dataColumns="datatable.columns"
      :dataFeed="datatable.dataFeed"
      :dataHandle="datatable.handle"
      :dataTableHeight="datatable.height"
      :defaultSortBy="datatable.sortBy"
      :defaultOrderBy="datatable.orderBy"
      :customSelectItem="selectItem"
      :customUnselectItem="unselectItem"
      :customAfterDeleteEvent="unselectItem"
      :allowView="allowView"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
      :hasContextMenu="hasContextMenu"
      :customRowStyle="customRowStyle"
    >
    <template slot="menuButtons" slot-scope="props">
      <template v-if="props.item && props.item.data">
        <li
          @click="$refs.datatable.viewItem($event, props.item.data)"
          v-if="allowView(props.item.data)"
        >View</li>
        <li
          @click="$refs.datatable.editItem($event, props.item.data)"
          v-if="allowEdit(props.item.data)"
        >Edit</li>
        <li
          @click="$refs.datatable.confirmDelete($event, props.item.data)"
          v-if="allowDelete(props.item.data)"
        >Delete</li>
      </template>
    </template>
    </DataTable>
    <VendorProjectHistory :selectedVendorProject="selectedVendorProject" v-if="selectedVendorProject" @reloadParent="reloadParent"/>

    <ImportModule 
      ref="importModule"
      @reload="reload"
      :uploadURL="$root.WebService.vendorproject + '/import/upload'" 
      :confirmURL="$root.WebService.vendorproject + '/import/confirm'"/>

  </div>
</template>
<script>

import VendorProjectHistory from './VendorProjectHistory/VendorProjectHistory'
import ImportModule from 'src/components/ImportModule'
import exportData from 'src/global/exportData.js'
import importData from 'src/global/importData.js'

export default {
  name: "VendorProject",
  components: {
    VendorProjectHistory,
    ImportModule
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Vendor Project',
        sectionName: 'vendorproject',
        sectionIcon: 'fab fa-buffer',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.vendorproject,
        navigation: [
          { name: 'Vendor Project', route: 'vendorproject.index' },
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'Vendor Project', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'vendorproject.index' }) } },
            { name: 'Project', icon: 'fab fa-buffer', action: () => { this.$router.push({ name: 'project.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: "vendorproject",
          webService: this.$root.WebService.vendorproject
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'created_at', title: 'Project Date', type: 'datepicker', width: '8%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
          {key: 'status', title: 'Status', type: 'select', width: '5%', value: null, datafilter: this.$options.filters.capitalize, selectOptions:
            {
              key: 'status', valueKey: 'value', displayKey: 'title', datas: [{ value: 'Launch', title: 'Launch' }, { value: 'EOL', title: 'EOL' }]
            }
          },
          { key: 'vendor_short_name', title: "Vendor", type: "input", width: '8%', value: null },
          { key: 'ref_no', title: "Ref No.", type: "input", width: '10%', value: null },
          { key: 'hs_part_no', title: "HS Part No", type: "input", width: '19%', value: null },
          { key: 'vendor_partno', title: 'Vendor Part No', type: "input", width: '19%', value: null },
          { key: 'vendor_specsheet', title: 'Spec.', type: 'select', width: '5%', value: null, datafilter: this.$options.filters.booleanText, selectOptions:
            {
              key: 'vendor_specsheet', valueKey: 'value', displayKey: 'title', datas: [{ value: 0, title: 'No' }, { value: 1, title: 'Yes' }]
            }
          },
          { key: 'latest_price_date', title: 'Price Date', type: 'datepicker', width: '8%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
          { key: 'latest_price', title: "Unit Price", type: "input", width: "7%", value: null, datafilter: this.$options.filters.numberFormat },
          { key: 'latest_price_terms', title: "Terms", type: "input", width: "5%", value: null },
          { key: 'latest_price_quantity', title: "Quantity", type: "input", width: "6%", value: null, datafilter: this.$options.filters.numberFormat },
        ],
        sortBy: null,
        orderBy: "desc",
        height: "70vh",
        scrollTop: null,
      },
      datas: [],
      filteredDatas: [],
      isEditing: false,
      selectedVendorProject: null,

      vendorsList: null,
      selectedVendor: '',

      formMode: null,
      exportFunction: {
        url: this.$root.WebService.vendorproject + '/export',
        fileName: 'ExportVendorProject'
      },
      showEOL: false,
    };
  },
  watch: {
    $route(to, from) {
      this.$emit('setPageHeader', this.pageSettings)
    },
    selectedVendor: {
      immediate: false,
      handler(id) {

        let vendor = this.vendorsList.find(item => item.id == id)

        if( vendor ) {
          this.datatable.dataFeed = {
            method: 'get',
            url: this.pageSettings.webService + '?vendor=' + vendor.id
          }

          if( this.$router.currentRoute.name != this.pageSettings.sectionName && this.$router.currentRoute.params.id != id)
            this.$router.push({ name: this.pageSettings.sectionName + '.index', params: { id: id }})

        }

        this.$nextTick(function () {

          this.$refs.datatable.doFilter()
          
        })
      }
    }
  },
  created() {
    this.getVendors()
  },
  mounted() {

    if( this.hasPermission('import vendorproject') ) this.pageSettings.buttons.push({ name: 'Import', icon: 'fas fa-file-upload', action: this.importData })
    if( this.hasPermission('export vendorproject') ) this.pageSettings.buttons.push({ name: 'Export', icon: 'fas fa-file-download', action: this.exportData })
    if (this.hasPermission('create vendorproject')) this.pageSettings.buttons.push({ name: 'Add New Vendor Project', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)

    this.datatable.handle = (res) => this.datas = res.data.data
    // this.datatable.dataFeed = {
    //   method: 'get',
    //   url: this.WebService.vendorproject
    // }
  },
  methods: {
    getVendors() {
      this.$http
        .get(this.WebService.vendor + '?enabled=1')
        .then((response) => {
          this.vendorsList = response.data.data

          if( this.$route.params.id ) 
          {
            let catID = this.$route.params.id
            this.selectedVendor = catID
          }

        })
        .catch(null)
        .finally(null)
    },
    selectItem(item, key) {
      if( !this.hasPermission('read vendorproject') ) return
      
      this.$refs.datatable.filteredDatas = [item]
      this.$refs.datatable.page = 1
      this.$refs.datatable.remain = 1
      this.$refs.datatable.$refs.virtualList.forceRender()

      this.selectedVendorProject = item
    },
    unselectItem(item, key) {
      this.selectedVendorProject = null

      this.$refs.datatable.doFilter()
      this.$refs.datatable.page = this.$refs.datatable.previousPage
      this.$refs.datatable.remain = null
      this.$refs.datatable.$refs.virtualList.forceRender()
    },
    showModalVendorContact(item) {
      this.selectedVendor = item
    },
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData,
    importData,
    allowView(item) {
      return this.hasPermission('read vendorproject')
    },
    allowEdit(item) {
      return this.hasPermission('update vendorproject')
    },
    allowDelete(item) {
      return false
      //return this.hasPermission('delete vendorproject')
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    customRowStyle(item) {
      if( item.status == 'EOL' )
        return {'background-color': '#ff6b6b'};
    },
    reloadParent(evt, item) {
      this.$refs.datatable.reset()
    },
    reload() {
      this.$refs.datatable.reload()
    }
  }
};
</script>